import { PayloadAction } from '@reduxjs/toolkit';
import { FetchTenantConfigPayload, TenantConfigResponse } from './tenantConfigTypes';
import { call, put, takeEvery } from 'redux-saga/effects';
import { fetchTenantConfig } from './tenantConfigActions';
import { getSpotConfig, getSpotModeratorsConfig } from '@host-panel/request/config';
import { parseTenantConfig } from './tenantConfigUtils';
import { addLoadingConfigs, removeLoadingConfigs, updateTenantConfig } from './tenantConfigSlice';

function* fetchTenantConfigSaga(action: PayloadAction<FetchTenantConfigPayload>) {
  const { spotId, defaultConfig, type } = action.payload;

  const request = type === 'admin' ? getSpotConfig : getSpotModeratorsConfig;

  const configs = Object.keys(defaultConfig);

  try {
    yield put(addLoadingConfigs(configs));

    const response: TenantConfigResponse = yield call(request, spotId, configs);

    const parsedConfig = parseTenantConfig(response);

    yield put(updateTenantConfig(parsedConfig));
  } catch (error) {
    yield put(updateTenantConfig(defaultConfig));
  }

  yield put(removeLoadingConfigs(configs));
}

export function* tenantConfigSagas() {
  yield takeEvery(fetchTenantConfig, fetchTenantConfigSaga);
}
